<template>
	<div>
		<div class="d-flex align-center">
			<v-autocomplete
				class="mr-4 filter-item"
				:value="filters.clientId"
				:items="clients"
				v-bind="commonSelectConfig"
				:itemText="item => `${item.id} ${item.name}`"
				item-text="name"
				item-value="id"
				label="Клиент"
				:filter="filterByText"
				:loading="loading.clients"
				@input="updateFilters('client_id', $event)"
			>
				<template v-slot:item="{ item }">
					<span><sup>{{ item.id }}</sup> {{ item.name }}</span>
				</template>
			</v-autocomplete>
			<v-select-project
				class="mr-4 filter-item"
				:value="filters.projectId"
				label="Проект"
				disable-client-id-from-url
				@input="updateFilters('project_id', $event)"
			/>
			<v-autocomplete
				class="mr-4 filter-item"
				:value="filters.tariffName"
				:items="tariffNames"
				label="Тариф"
				v-bind="commonSelectConfig"
				@input="updateFilters('tariff_name', $event)"
			/>
			<v-text-field
				class="mr-4 filter-item"
				label="Хост проекта"
				:value="filters.main_project_host"
				@input="updateFilters('main_project_host', $event)"
				type="string"
				outlined
				dense
				v-bind="commonSelectConfig"
			></v-text-field>
		</div>
	</div>
</template>

<script>
import selectProject from '@/components/selectProject'
import { mapState } from 'vuex'
import { filterByText } from '@/function/filter'
import debounce from 'lodash/debounce'

export default {
	name: 'filters',
	components: {
		'v-select-project': selectProject
	},
	props: {
		filters: {
			type: Object,
			required: true
		},
		loading: {
			type: Object,
			required: true
		},
		tariffNames: {
			type: Array,
			required: true
		}
	},

	data () {
		return {
			commonSelectConfig: {
				outlined: true,
				dense: true,
				hideDetails: true,
				clearable: true
			}
		}
	},

	computed: {
		...mapState({
			clients: state => state.clients
		})
	},

	methods: {
		updateFilters (name, value) {
			switch (name) {
			case ('client_id'):
			case ('project_id'):
			case ('main_project_host'):
				this.$emit('update-filters', { [name]: value != null ? String(value) : undefined })
				break
			case 'update_limits_prc':
				this.debouncedTariffNameFilter(value)
				break
			default:
				this.$emit('update-filters', { [name]: value || undefined })
			}
		},
		filterByText,
		debouncedTariffNameFilter: debounce(function (value) {
			this.$emit('update-filters', { update_limits_prc: value || undefined })
		}, 700)
	}
}
</script>

<style scoped lang="scss">
.filter-item {
	max-width: 300px;
}

</style>
